export default {"src":"/_next/static/media/adobeaudition.96b89ff6.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};